import {remCalc} from '../../_utils'
//

export default {
    baseStyle: {
        container: {
            width: 'full',
            alignItems: 'center',
        },
        divider: {
            borderLeft: 'small',
            borderColor: 'border.light',
            height: 'auto',
        },
        popoverContent: {
            marginLeft: 'auto',
            marginRight: 'auto',
            border: 0,
            minWidth: '100%',
            position: 'absolute',
        },
        popoverBody: {
            boxShadow: 'xl',
            paddingTop: 3,
            paddingRight: 4,
            paddingBottom: 4,
            paddingLeft: 4,
            zIndex: 1,
        },
        popoverContainer: {
            paddingTop: 0,
            paddingBottom: 8,
            maxWidth: 'container.xxxl',
        },
        listMenuTriggerContainer: {
            position: 'relative',
            textStyle: 'body-large',
            color: 'text.secondary',
            display: 'flex',
            alignItems: 'center',
            gap: remCalc(8),
            pr: remCalc(20),
            _after: {
                content: '""',
                display: 'block',
                position: 'absolute',
                top: '100%',
                left: 0,
                right: 0,
                height: remCalc(42),
                background: 'transparent',
            },
        },
        listMenuTriggerGroup: {
            display: 'flex',
            alignItems: 'center',
            gap: remCalc(8),
        },
        listMenuSimpleTriggerLink: {
            cursor: 'pointer',
            zIndex: '2',
            fontWeight: 'bold',
            _hover: {
                textDecoration: 'none',
            },
        },
        listMenuTriggerLink: {
            cursor: 'pointer',
            fontWeight: '600',
            zIndex: '2',
            position: 'relative',
            _hover: {
                textDecoration: 'none',
                _after: {
                    content: '""',
                    display: 'block',
                    position: 'absolute',
                    top: '100%',
                    left: 0,
                    right: 0,
                    height: remCalc(26),
                    borderBottom: 'large',
                    background: 'transparent',
                },
                '@media (min-width: 1400px)': {
                    _after: {
                        content: '""',
                        display: 'block',
                        position: 'absolute',
                        top: '100%',
                        left: 0,
                        right: 0,
                        height: remCalc(26),
                        borderBottom: 'large',
                        background: 'transparent',
                    },
                },
            },
        },
        listMenuTriggerLinkActive: {
            color: 'text.default',
            position: 'relative',
            _after: {
                content: '""',
                display: 'block',
                position: 'absolute',
                top: '100%',
                left: 0,
                right: 0,
                height: remCalc(26),
                borderBottom: 'large',
                background: 'transparent',
            },
            '@media (min-width: 1400px)': {
                _after: {
                    content: '""',
                    display: 'block',
                    position: 'absolute',
                    top: '100%',
                    left: 0,
                    right: 0,
                    height: remCalc(26),
                    borderBottom: 'large',
                    background: 'transparent',
                },
            },
        },
        listMenuContent: {
            px: remCalc(16),
            w: '100%',
            bg: 'background.default',
        },
        popoverOverlay: {
            pos: 'absolute',
            backgroundColor: 'background.overlay-modal',
            height: '100vh',
            zIndex: '-2',
            top: '100%',
            left: 0,
            right: 0,
        },
        categoryContainer: {
            w: 'full',
            gap: {base: remCalc(24), lg: remCalc(48)},
            justifyContent: 'space-between',
        },
        subCategoryContainer: {
            w: 'full',
            justifyContent: 'space-between',
        },
        contentContainer: {
            maxW: 'container.xxl',
            m: 'auto',
            direction: 'column',
        },
        footerText: {
            color: 'text.tertiary',
            textStyle: 'body-small',
            fontWeight: '600',
        },
        footerTextHeader: {
            color: 'text.tertiary',
            textStyle: 'body-xsmall',
            fontWeight: '600',
        },
        footerContainer: {
            position: 'relative',
            py: {base: remCalc(16), sm: remCalc(24), md: remCalc(80)},
            gap: remCalc(24),
        },
        exploreAllButton: {
            w: '100%',
            textStyle: 'body-xsmall',
            color: 'text.primary',
            fontWeight: 'bold',
            _hover: {
                textDecoration: 'none',
            },
        },
        mainDivider: {
            position: 'absolute',
            top: 0,
            left: '50%',
            transform: 'translateX(-50%)',
            width: {base: '97vw', '2xl': '99vw'},
            borderBottom: 'small',
            borderColor: 'border.light',
        },
        filterHeaderContainer: {
            display: 'flex',
            alignItems: 'center',
            top: `-${remCalc(36)}`,
            gap: remCalc(5),
            mb: remCalc(12),
        },
        filterHeaderContainerBreakpoint: {
            '@media (min-width: 1200px)': {
                position: 'absolute',
            },
        },
        filterHeaderText: {textStyle: 'body-small', color: 'text.primary'},
        filterheaderTag: {
            alignItems: 'center',
            textStyle: 'body-xxsmall',
            rounded: 'full',
            gap: remCalc(4),
            fontWeight: '500',
            p: `${remCalc(2)} ${remCalc(8)} ${remCalc(2)} ${remCalc(5)}`,
        },
        subCategoryHeaderContainer: {
            display: 'flex',
            gap: {lg: remCalc(16)},
            justifyContent: {base: 'space-between', lg: 'flex-start'},
            mb: {base: remCalc(16), md: remCalc(12), lg: remCalc(24)},
        },
        subCategoryHeaderText: {
            textStyle: {base: 'body-medium', md: 'body-small', lg: 'body-large'},
            color: 'text.primary',
            fontWeight: 'bold',
        },
        subCategoryHeaderLink: {
            textStyle: 'body-medium',
            color: 'button.text.text-default',
            fontWeight: 'bold',
            textDecoration: 'underline',
        },
        cardGroupContainer: {
            pt: {base: remCalc(0), sm: remCalc(0), lg: remCalc(40)},
            pb: {base: remCalc(16), sm: remCalc(16), lg: remCalc(40)},
            spacing: {base: remCalc(8), sm: remCalc(16), md: remCalc(24)},
            display: 'flex',
            flexWrap: 'wrap',
        },
        cardGroupContainerFlex: {
            pt: {base: remCalc(0), sm: remCalc(0), lg: remCalc(40)},
            pb: {base: remCalc(16), sm: remCalc(16), lg: remCalc(40)},
            rowGap: {base: remCalc(16), md: remCalc(24)},
            columnGap: {base: remCalc(8), md: remCalc(24)},
            justifyContent: 'flex-start',
            flexWrap: 'wrap',
        },
        secondLevelFooter: {
            borderBottom: 'small',
            borderTop: 'small',
            borderColor: 'border.light',
            direction: 'column',
            pt: remCalc(16),
            gap: remCalc(16),
        },
        tertiaryLink: {
            textStyle: 'body-small',
            color: 'text.default',
            fontWeight: '600',
            textDecoration: 'underline',
        },
        drawerBody: {
            px: {base: remCalc(16), sm: remCalc(24), md: remCalc(25)},
            py: {base: remCalc(20), sm: remCalc(30), md: remCalc(40)},
        },
        drawerHeader: {
            p: 0,
            pb: remCalc(21),
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            w: '100%',
        },
        breadcrumbContainer: {gap: remCalc(10), align: 'center'},
        breadcrumbText: {
            textStyle: 'body-small',
            fontWeight: '400',
            lineHeight: 'unset',
            color: 'text.default',
        },
        firstLevelGrid: {
            gap: {base: remCalc(16)},
        },
        firstLevelCategoriesGrid: {
            gap: {base: remCalc(8)},
        },
        firstLevelSecondaryGrid: {
            columns: 2,
            gap: {base: remCalc(8), sm: remCalc(16), md: remCalc(24)},
        },
        headerLinks: {gap: {base: remCalc(10), md: remCalc(16), lg: remCalc(24)}},
        headerIconSize: {boxSize: 'iconsSize.small'},
        svgContainer: {
            h: remCalc(16),
            w: remCalc(16),
            alignItems: 'center',
            justifyContent: 'center',
        },
        secondaryCardsGrid: {gap: {base: remCalc(8), sm: remCalc(16), md: remCalc(24)}},
        secondLevelContainer: {
            pt: {base: remCalc(16)},
            maxW: 'container.xxl',
            m: 'auto',
            direction: 'column',
        },
        secondLevelCategoryGrid: {
            pt: {base: remCalc(16)},
            gap: {base: remCalc(16), md: remCalc(24)},
        },
        secondLevelExploreAll: {
            w: '100%',
        },
        secondLevelGrid: {gap: remCalc(16)},
        menuSupportLink: {
            _hover: {
                textDecoration: 'none',
                cursor: 'initial',
            },
        },
    },
    parts: [],
}
